import dynamic from 'next/dynamic';
import React from 'react';

import { Modal } from '~components/Modals/Base';

import type { LoginModalProps } from '../../model/types';
const Content = dynamic(
	() => import('./dynamicContent').then((mod) => mod.Content),
	{
		ssr: false,
	}
);

export const LoginModal = ({
	open,
	locked,
	onClose,
	...props
}: LoginModalProps) => {
	return (
		<Modal open={open} locked={locked} onClose={onClose}>
			<Content open={open} locked={locked} onClose={onClose} {...props} />
		</Modal>
	);
};
